<script setup>
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";
  import {wishesAims} from "@pages/Patientinput/Enums.js";
  import {MedCheckbox, MedFormField, MedLabel} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputComponentStepWishesAims",
  });

  const props = defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  const isSelected = (key) => props.form.wishes_aims.includes(key);

  const checkboxChanged = (key, selected) => {
    props.form.wishes_aims = props.form.wishes_aims.filter((iKey) => iKey !== key);

    if (selected) {
      props.form.wishes_aims.push(key);
    }
  };
</script>

<template>
  <PatientinputComponentStep title="Wünsche und Ziele" :test-id="getTestId()">
    <p>Was sind Ihre Wünsche und Ziele für die Medikationsberatung und das Gespräch?</p>

    <MedFormField v-for="(label, key, index) in wishesAims" :key="index" orientation="horizontal" size="mobile">
      <MedCheckbox
        :model-value="isSelected(key)"
        variant="primary"
        :data-test="getTestId(`wishes-aims-step-${index}-checkbox`)"
        @change="(event) => checkboxChanged(key, event)"
      />

      <MedLabel>{{ label }}</MedLabel>
    </MedFormField>
  </PatientinputComponentStep>
</template>
